import { Row as AntRow } from 'antd';
import styled from 'styled-components';

interface RowProps {
  vertical?: boolean;
}

export const Row = styled(AntRow)<RowProps>`
  flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};
`;
